import {ModuleCode} from '../platform'
import {academicAdvisingRouteManifest} from './academic-advising/manifest'
import {academicWorkloadRouteManifest} from './academic-workload/manifest'
import {adminRouteManifest} from './admin/manifest'
import {analyticsRouteManifest} from './analytics/manifest'
import {assessmentRouteManifest} from './assessment/manifest'
import {bapRouteManifest} from './bap/manifest'
import {committeeRouteManifest} from './committee/manifest'
import {courseExamScheduleRouteManifest} from './course-exam-schedule/manifest'
import {curriculumRouteManifest} from './curriculum/manifest'
import {graduateCardRouteManifest} from './graduate-card/manifest'
import {qualityRouteManifest} from './quality/manifest'
import {studentClearanceRouteManifest} from './student-clearance/manifest'
import {surveyFeedbackRouteManifest} from './survey-feedback/manifest'
import {ModuleRouteManifest} from './types'

export const MODULE_ROUTE_MANIFESTS: Readonly<Record<ModuleCode, ModuleRouteManifest>> = {
  quality: qualityRouteManifest,
  curriculum: curriculumRouteManifest,
  'survey-feedback': surveyFeedbackRouteManifest,
  assessment: assessmentRouteManifest,
  'course-exam-schedule': courseExamScheduleRouteManifest,
  'academic-advising': academicAdvisingRouteManifest,
  bap: bapRouteManifest,
  committee: committeeRouteManifest,
  'student-clearance': studentClearanceRouteManifest,
  'graduate-card': graduateCardRouteManifest,
  'academic-workload': academicWorkloadRouteManifest,
  analytics: analyticsRouteManifest,
  admin: adminRouteManifest,
}

export function normalizeRouteDefinition(path: string) {
  return path.trim().replace(/^\/+/, '')
}

export function isModulePrivateRoute(moduleCode: ModuleCode, path: string) {
  const normalizedPath = normalizeRouteDefinition(path)
  return MODULE_ROUTE_MANIFESTS[moduleCode].privateRoutes.some(
    (route) => normalizeRouteDefinition(route) === normalizedPath
  )
}

export function isModuleNavigationRoute(moduleCode: ModuleCode, path: string) {
  const normalizedPath = normalizeRouteDefinition(path).split('?')[0].split('#')[0]

  return MODULE_ROUTE_MANIFESTS[moduleCode].privateRoutes.some((route) => {
    const normalizedRoute = normalizeRouteDefinition(route)
    const wildcardBase = normalizedRoute.endsWith('/*')
      ? normalizedRoute.slice(0, -2)
      : normalizedRoute

    return (
      normalizedPath === normalizedRoute ||
      normalizedPath === wildcardBase ||
      (normalizedRoute.endsWith('/*') && normalizedPath.startsWith(`${wildcardBase}/`))
    )
  })
}

export type {ModuleRouteManifest} from './types'
